import {
  SET_DATA_FOR_3D_SECURE,
  SET_DATA_FOR_PENDING_PAYMENT,
  SET_PAYMENT_ENGINE,
  SET_ADYEN_PAYMENT_TYPE,
  SET_PAYMENT_FEATURE_FLAGS,
} from 'svr/component-lib/Widget/Payments/ActionTypes'
import { getConfigProvider } from '@sevenrooms/connect-config'

export const setDataFor3Dsecure = dataFor3Dsecure => ({
  type: SET_DATA_FOR_3D_SECURE,
  dataFor3Dsecure,
})

export const setPendingPaymentContext = data => ({
  type: SET_DATA_FOR_PENDING_PAYMENT,
  data,
})

export const setAdyenPaymentType = data => ({
  type: SET_ADYEN_PAYMENT_TYPE,
  data,
})

export const setPaymentEngine = paymentEngine => ({
  type: SET_PAYMENT_ENGINE,
  paymentEngine,
})

export const setPaymentsFeatureFlags = paymentsFeatureFlags => ({
  type: SET_PAYMENT_FEATURE_FLAGS,
  paymentsFeatureFlags,
})

export const setIsEnabledUseCybersourceFlexV2 = provider => dispatch => {
  const useCybersourceFlexV2 = provider.isEnabled('payments.cybersource.flex_v2')
  dispatch(setPaymentsFeatureFlags({ useCybersourceFlexV2 }))
}

export const getPaymentsFeatureFlags = venueUrlKey => async dispatch => {
  const provider = await getConfigProvider({
    prefabApiKey: window?.widgetInit?.prefabKey ? window.widgetInit.prefabKey : window?.PREFAB_API_KEY,
    contexts: {
      venueUrlKey: [venueUrlKey],
    },
  })
  dispatch(setIsEnabledUseCybersourceFlexV2(provider))
}
